module.exports = __webpack_public_path__ + "img/syimg3.a931a120.png";